export const FETCH_ITEMS = `${process.env.baseUrl}/headless/cart/index`;
export const CHANGE_QTY = `${process.env.baseUrl}/headless/cart`;
export const DELETE_ITEM = `${process.env.baseUrl}/headless/cart/delete/id`;
export const DELETE_CART = `${process.env.baseUrl}/headless/cart/index`;
export const UPDATE_BY_KDMAX_CART_TYPE = `${process.env.baseUrl}/kitchens/cart/update`;
